/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineChildrenServiceCountDto } from './traveline-children-service-count-dto';
import {
    TravelineChildrenServiceCountDtoFromJSON,
    TravelineChildrenServiceCountDtoFromJSONTyped,
    TravelineChildrenServiceCountDtoToJSON,
    TravelineChildrenServiceCountDtoToJSONTyped,
} from './traveline-children-service-count-dto';

/**
 * Number of extra services provided depending on the age of the guests
 * @export
 * @interface TravelineQuantityByGuestsDto
 */
export interface TravelineQuantityByGuestsDto {
    /**
     * Number of extra services for adult guests
     * @type {number}
     * @memberof TravelineQuantityByGuestsDto
     */
    adultsServiceQuantity?: number;
    /**
     * Number of extra services for child guests
     * @type {Array<TravelineChildrenServiceCountDto>}
     * @memberof TravelineQuantityByGuestsDto
     */
    childrenServiceQuantity?: Array<TravelineChildrenServiceCountDto> | null;
}

/**
 * Check if a given object implements the TravelineQuantityByGuestsDto interface.
 */
export function instanceOfTravelineQuantityByGuestsDto(value: object): value is TravelineQuantityByGuestsDto {
    return true;
}

export function TravelineQuantityByGuestsDtoFromJSON(json: any): TravelineQuantityByGuestsDto {
    return TravelineQuantityByGuestsDtoFromJSONTyped(json, false);
}

export function TravelineQuantityByGuestsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineQuantityByGuestsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'adultsServiceQuantity': json['adultsServiceQuantity'] == null ? undefined : json['adultsServiceQuantity'],
        'childrenServiceQuantity': json['childrenServiceQuantity'] == null ? undefined : ((json['childrenServiceQuantity'] as Array<any>).map(TravelineChildrenServiceCountDtoFromJSON)),
    };
}

  export function TravelineQuantityByGuestsDtoToJSON(json: any): TravelineQuantityByGuestsDto {
      return TravelineQuantityByGuestsDtoToJSONTyped(json, false);
  }

  export function TravelineQuantityByGuestsDtoToJSONTyped(value?: TravelineQuantityByGuestsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adultsServiceQuantity': value['adultsServiceQuantity'],
        'childrenServiceQuantity': value['childrenServiceQuantity'] == null ? undefined : ((value['childrenServiceQuantity'] as Array<any>).map(TravelineChildrenServiceCountDtoToJSON)),
    };
}

